export default "__VITE_ASSET__DEe7Osaa__"